import React from "react";
import styles from './FeaturedOffers.module.css';
import FeaturedOffersCarousel from './FeaturedOffersCarousel';

const FeaturedOffers = ({ products }) => {
    if (!products || products.length === 0) return null;
    // Adaptar los datos para el carrusel
    const offers = products.map(prod => ({
        id: prod.id,
        image: prod.primary_image,
        title: prod.name,
        price: prod.price,
        originalPrice: prod.original_price,
        slug: prod.slug,
    }));
    return (
        <div className={styles.featuredOffers}>
            <FeaturedOffersCarousel offers={offers} />
        </div>
    );
};

export default FeaturedOffers;